// dependencies
import React from "react";

import { AIPromotionalButton } from "../../../../../../components/AIModules/AIPromotionalButton/AIPromotionalButton";
import Text from "../../../../../../components/Text";
import { CardBody, CardHeader } from "../../../../components/Card";
import QuestionsTable from "./QuestionsTable";
import QuestionsTableToolbar from "./QuestionsTableToolbar";

import { useCustomFactors } from "../../../../../../api/hooks";
import { useAiPromotion } from "../../../../../../hooks/useAiPromotion";
import { useFeatureFlagQuery } from "../../../../../../hooks/useFeatureFlag";
import useQuestionTableRows from "./useQuestionTableRows";

// utils
import downloadCSV from "../../../../../../utils/downloadCSV";

// styles
import css from "./QuestionsTable.module.scss";

const QuestionsTableCard = () => {
	const { isAiPromotion, promotionId, userEmail } = useAiPromotion();
	const { value: customFactorsEnabled } = useFeatureFlagQuery("ff-engagement-custom-factors", false);
	const { data: customFactorsData } = useCustomFactors({ enabled: customFactorsEnabled });

	const [searchInput, setSearchInput] = React.useState("");

	const onSearchChanged = (searchTerm: string) => {
		if (searchTerm !== searchInput) {
			setSearchInput(searchTerm);
		}
	};

	const {
		rows,
		isLoading,
		getCSVContent,
		selectCSVDownloadName,
		handleDownloadQuestionAnswers,
		handleDownloadNPSAdditionalFeedback,
		getRowInformation,
	} = useQuestionTableRows(searchInput);

	return (
		<>
			<CardHeader
				title={
					<Text element="span" size="paragraph-2" weight="semi-bold">
						All Questions
					</Text>
				}
				info="Filterable and searchable list of available satisfaction and engagement factor questions."
				toolBar={
					<div className="mr-2 flex items-center gap-2">
						<QuestionsTableToolbar
							onSearch={onSearchChanged}
							additionalFeedbackQuestionEnabled={true}
							customFactorsEnabled={customFactorsEnabled}
							customFactorsData={customFactorsData?.customFactors?.map((f) => ({ name: f.name }))}
						/>
						{isAiPromotion && (
							<AIPromotionalButton label="AI Insights" promotionId={promotionId} userEmail={userEmail} />
						)}
					</div>
				}
				options={[
					{
						id: "download-csv",
						label: "Download CSV",
						action: () => {
							const csvContent = getCSVContent();
							const filename = selectCSVDownloadName();
							downloadCSV(csvContent ?? "", filename);
						},
					},
				]}
			/>
			<CardBody>
				<div className={css.cardBody}>
					<QuestionsTable
						rows={rows}
						isLoading={isLoading}
						handleDownloadQuestionAnswers={handleDownloadQuestionAnswers}
						getRowInformation={getRowInformation}
						handleDownloadNPSAdditionalFeedback={handleDownloadNPSAdditionalFeedback}
						customFactorsEnabled={customFactorsEnabled}
					/>
				</div>
			</CardBody>
		</>
	);
};

export default QuestionsTableCard;
